import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { FormatNumberPipe, FormatNumberPipe2, FormatNumberPipe3 } from '../../../../core/pipe/custom-pipes';
import { BadgeVehiclePipe } from '../../../../core/pipe/badge-vehicle.pipe';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';

interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}

@Component({
  selector: 'app-campaign-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormatNumberPipe,
    FormatNumberPipe2,
    FormatNumberPipe3,
    BadgeVehiclePipe,
    CommonModule],
  templateUrl: './campaign-form.component.html',
  styleUrl: './campaign-form.component.css'
})
export class CampaignFormComponent {
  @Input() orderData?: any;
  @Input() ladata: any = [];
  @Output() emitSubmit = new EventEmitter<string>();
  account_type = this.authStateService.getAccountType();
  @ViewChild('ivaCheckbox') ivaCheckbox!: ElementRef;
  generalForm: FormGroup = new FormGroup({});
  matrix_total: any = {};
  draft = false;
  order_reference: string = '';
  stage?: any;
  newStage: string = '';

  role: any;

  back = "";
  next_ok = "";
  next_ko = "";
  btn_fast_actions = false;
  agentData: AccountData[] = [];
  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  supplierData: AccountData[] = [];
  campaignsData: any[] = [];
  supplierTypeData: any[] = [{ name: 'Prescripción broker', key: 'referral_broker' }, { name: 'Prescripción devolución', key: 'referral_vendor' }];
  supplierSellerCodes: any[] = [];

  newCampaign: any = null;
  duration: string = '';
  monthly_fee_base: number = 0;
  yearly_kms: string = '';
  durationOptions: string[] = ['12', '24', '36', '48', '60', '72'];
  yearlyKmsOptions: string[] = ['5000', '7500', '10000', '15000', '20000', '25000', '30000', '35000', '40000', '45000', '50000'];


  constructor(private fb: FormBuilder, private authStateService: AuthStateService, private modelService: ModelService, private alertService: AlertService, private localStorageService: LocalStorageService, private orderService: OrdersService) {
    this.generalForm = this.fb.group({
      broker_id: [''],
      broker_agent_id: [''],
      broker_reference: ['', Validators.required],
      campaign_id: ['', Validators.required],
      yearly_kms: [''],
      duration: [''],
    });
  }

  columns: string[] = [];
  rows: string[] = [];

  ngOnInit(): void {
  }

  selectedOpt: boolean = false;
  colKey: string = '';
  rowKey: string = '';

  handleClick(column: string, row: string) {
    this.selectedOpt = true;
    this.colKey = column;
    this.rowKey = row;
    const matrix = this.campaignsData.find((campaign: any) => campaign.reference === this.newCampaign)?.matrix_base || {};
    const value = matrix[this.colKey]?.[this.rowKey] ?? null;
    this.duration = column;
    this.monthly_fee_base = value;
    this.yearly_kms = row;
  }


  ngAfterViewInit() {


  }
  isDisabled = false;

  toggleDisabled(): void {
    this.isDisabled = !this.isDisabled;
  }
  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.matrix_total = this.campaignsData.find((campaign: any) => campaign.reference === this.newCampaign)?.matrix_total || {};
      this.updateMatrixTotal();
    } else {
      this.matrix_total = this.campaignsData.find((campaign: any) => campaign.reference === this.newCampaign)?.matrix_base || {};
      this.updateMatrixTotal();
    }
  }
  customConfig: boolean = false;
  onCheckboxChange2(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.customConfig = true;
    } else {
      this.customConfig = false;
    }
  }

  check_selects_length() {
    if (this.agentData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_agent_id: this.agentData[0].reference });
      this.generalForm.patchValue({ supplier_agent_id: this.agentData[0].reference });
    }
    if (this.brokerData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_id: this.brokerData[0].reference });
    }
    if (this.supplierData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ supplier_id: this.supplierData[0].reference });
    }
    if (this.vendorData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ vendor_id: this.vendorData[0].reference });
    }
  }

  checkUpdateForm(): boolean {
    if (this.generalForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
       /*  if (this.ladata.typeOrders) { */
          this.role = this.authStateService.getRole();
          this.agentData = this.ladata.agentData;
          this.vendorData = this.ladata.vendorData;
          this.brokerData = this.ladata.brokerData;
          this.supplierSellerCodes = this.ladata.supplierSellerCodes;
          this.supplierData = this.ladata.supplierData;
          this.campaignsData = this.ladata.campaignData;
          this.filteredCampaigns = this.campaignsData;
          if (this.account_type == 'broker' && !this.draft) {
            this.generalForm.controls['broker_agent_id'].setValue(
              this.authStateService.getUserReference()
            );
          }
          if (this.orderData) {
            this.refrescarFormulario();
          }
          this.check_selects_length();
        }
    /*   } */

      if (changes['orderData']) {
        if (this.orderData) {
          this.refrescarFormulario();
        }
      }
    }
  }
  campaign: any = null;
  changeCampaign(event: any) {
    this.newCampaign = event.target.value;
    this.campaign = this.campaignsData.find((campaign: any) => {

      return campaign.reference === this.newCampaign;
    });
    this.matrix_total = this.campaignsData.find((campaign: any) => campaign.reference === this.newCampaign)?.matrix_total || {};
    this.updateMatrixTotal();
  }

  updateMatrixTotal() {
    this.columns = Object.keys(this.matrix_total).sort((a, b) => +a - +b);
    // Extraer filas (kms)
    const kmSet = new Set<string>();
    Object.values(this.matrix_total).forEach(row => {
      Object.keys(row as object).forEach(km => kmSet.add(km));
    });

    this.rows = Array.from(kmSet).sort((a, b) => +a - +b);

    if (this.selectedOpt) {
      this.handleClick(this.colKey, this.rowKey);
    }
  }

  refrescarFormulario() {

    this.setVariables();
     setTimeout(() => {
      if (this.ivaCheckbox?.nativeElement) {
        this.ivaCheckbox.nativeElement.checked = true;
      }
    });
    this.updateFieldAccessibility();
    for (const key in this.orderData) {
      const control = this.generalForm.controls[key];
      const value = this.orderData[key];
      if (control) {
        control.setValue(value);
      }
      if (control) {
        switch (key) {
          case 'broker_agent_id':
            if (this.account_type === 'broker') {
              control.setValue(value);
            } else {
              const brokerAgentName = `${this.orderData?.broker_agent?.name || ''} ${this.orderData?.broker_agent?.lastname || ''}`.trim();
              this.generalForm.get('broker_agent')?.setValue(brokerAgentName);
              control.setValue(value);
            }
            break;
          case 'supplier_agent_id':
            if (this.account_type === 'supplier') {
              control.setValue(value);
            } else {
              const supplierAgentName = `${this.orderData?.supplier_agent?.name || ''} ${this.orderData?.supplier_agent?.lastname || ''}`.trim();
              this.generalForm.get('supplier_agent')?.setValue(supplierAgentName);
              control.setValue(value);
            }
            break;
          default:
            control.setValue(value);
            break;
        }
      }
    }
    this.btn_fast_actions = this.orderData?.next_ok || this.orderData?.next_ko ? true : false;
    this.alertService.close();
  }

  updateFieldAccessibility() {
    var rules = { ... this.orderData?.rules };
    // Deshabilitar todos los campos por defecto
    for (const field in this.generalForm.controls) {
      if (this.generalForm.controls.hasOwnProperty(field)) {
        this.generalForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.generalForm.get(field)?.enable();
      }
    }

  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  setVariables() {
    this.back = this.orderData?.back || '';
    this.next_ok = this.orderData?.next_ok;
    this.next_ko = this.orderData?.next_ko;
    this.stage = this.orderData?.stage;
    this.draft = this.orderData ? true : false;
    this.order_reference = this.orderData?.reference;
  }



  getForm() {
    let formData;
    const values = this.generalForm.value;
    if (this.customConfig) {
      formData = {

        duration: values.duration,
        yearly_kms: values.yearly_kms,
        total_kms: (Number(values.yearly_kms) * (Number(values.duration) / 12)).toFixed(0),
      };
    } else {
      formData = {
        duration: this.duration,
        monthly_fee_base: this.monthly_fee_base,
        monthly_fee_tax: +(this.monthly_fee_base * (this.authStateService.getSupplierTax() || 0.21)).toFixed(2),
        monthly_fee_total: +(this.monthly_fee_base * (1 + (this.authStateService.getSupplierTax() || 0.21))).toFixed(2),
        yearly_kms: this.yearly_kms,
        total_kms: (Number(this.yearly_kms) * (Number(this.duration) / 12)).toFixed(0)
      };
    }

    return {
      ...this.generalForm.value,
      ...formData,
    };
  }

  ////////////////////////////////////////////

  filteredCampaigns: any[] = [];
  displayTextCampaign = '';
  optionsVisibleCampaign = false;
  clientCampaignTerm = '';
  onSelectCampaign(event: any) {
    this.generalForm.get('campaign_id')?.setValue(event.reference);
    this.displayTextCampaign = event.name;
    this.optionsVisibleCampaign = false;

    this.newCampaign = event.reference;
    this.campaign = this.campaignsData.find((campaign: any) => {
      return campaign.reference === this.newCampaign;
    });
   
    this.matrix_total = this.campaignsData.find((campaign: any) => campaign.reference === this.newCampaign)?.matrix_total || {};
    this.updateMatrixTotal();

  }

  filterCampaigns(event: any) {
    const text = event.target.value.toLowerCase();
    this.filteredCampaigns = this.campaignsData.filter(c =>
      c.name.toLowerCase().includes(text)
    );

  }


  onFocus(term: string) {
    if (term === 'campaign') {
      this.optionsVisibleCampaign = true;
    }
  }

  searchCampaigns(term: any) {

    this.clientCampaignTerm = term.value;
    let search = term.value;

    this.filteredCampaigns = this.campaignsData.filter((clientData: any) =>
      clientData.name.toLowerCase().includes(search.toLowerCase())
    );


  }
  hideOptions() {
    this.optionsVisibleCampaign = false;
  }

  getMinFee(campaign: any): number | null {
    const matrix = campaign?.matrix_total || campaign?.matrix_base;
    if (!matrix) return null;
    const values = Object.values(matrix).flatMap(row => Object.values(row as object)) as number[];
    return values.length ? Math.min(...values) : null;
  }
}
